import GoalMenu from "@/pages/models/release/GoalMenu";
import { useParsedGraph } from "@/pages/models/release/GraphContext";
import { useRelease } from "@/pages/models/release/ReleaseContextProvider";
import Dialog from "@imminently/decisively-ui/Dialog";
import { DialogHeader } from "@/ui/dialogs/DialogHeader";

export interface HighlightConnectedToRootModal {
  open: boolean;
  onClose: () => void;
}

const HighlightConnectedToRootModal = (props: HighlightConnectedToRootModal) => {
  const { open, onClose } = props;
  const graph = useParsedGraph();
  const { setHighlightConnectedTo, highlightConnectedTo } = useRelease();

  return (
    <Dialog
      intent={"compact"}
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
    >
      <Dialog.Content>
        <DialogHeader title="Highlight Connected Nodes" description="Highlight any nodes that are not connected to:" />
        <Dialog.Body>
          <GoalMenu
            goalId={highlightConnectedTo}
            onGoalIdChange={setHighlightConnectedTo}
            allowEmpty={true}
            includeDerived={false}
            includeInputs={false}
            graph={graph}
          />
        </Dialog.Body>
        <Dialog.Actions/>
      </Dialog.Content>
    </Dialog>
  );
};

export default HighlightConnectedToRootModal;
